import { render } from "./ClintsCases.vue?vue&type=template&id=7356bbb5"
import script from "./ClintsCases.vue?vue&type=script&lang=js"
export * from "./ClintsCases.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__